import {cr} from 'fire-wind-water';
import {Elem} from './elem';
import {datePicker} from './virtual/date';
import {interact} from 'fire-wind-water';
import {relustList} from './core/list';
import {initTrTd} from './virtual/trthtd';

class DatePicker extends Elem {
  constructor(o) {
    super(o);
    this.resetModel = ['year', 'month', 'date'];
  }

  setList() {
    this.list = relustList('date', this.value, this.model);
  }

  setModel(o) {
    const date = cr.isDate(o) ? o : new Date();
    this.setValue(date);
    this.resetRender();
  }

  resetRender(d) {
    if (interact.isMobile === 1) {
      this.resetWapRender(d);
    } else {
      this.setList();
      this.setVirtual();
      this.render();
    }
  }

  initTrAndTh() {
    const arr = ['一', '二', '三', '四', '五', '六', '日'];
    const tr = [
      {
        h: 'tr', c: '', z: []
      }
    ];
    cr.each(arr, d => {
      const th = {h: 'td', c: '', html: d};
      tr[0].z.push(th);
    });
    return tr;
  }

  setVirtual() {
    const trs = initTrTd('date', this.list, 7, (o, ev) => {
      this.selectItem(ev, o);
    });
    const ths = this.initTrAndTh();
    this.virtual = datePicker(this, ths, trs);
  }

  selectItem(ev, o) {
    if (this.isTime) {
      ev.stopPropagation();
    }
    this.model = this.toDate(o);
    this.updateValue();
    this.resetRender();
    if (!this.isTime) {
      this.change({model: this.model, value: this.value});
    }
  }

  selectFirst(ev) {
    if (ev) {
      ev.stopPropagation();
    }
    this.value.year--;
    this.resetRender();
  }

  selectLast(ev) {
    if (ev) {
      ev.stopPropagation();
    }
    this.value.year++;
    this.resetRender();
  }

  selectFirstMonth(ev) {
    if (ev) {
      ev.stopPropagation();
    }
    this.value.month--;
    if (this.value.month <= 0) {
      this.value.month = 12;
      this.value.year--;
    }
    this.resetRender();
  }

  selectLastMonth(ev) {
    if (ev) {
      ev.stopPropagation();
    }
    this.value.month++;
    if (this.value.month > 12) {
      this.value.month = 1;
      this.value.year++;
    }
    this.resetRender();
  }

  selectThatDay() {
    this.model = new Date();
    this.updateValue();
    this.change({model: this.model, value: this.value});
    this.destroy();
  }

  changeModel() {
    this.touchs.changeModel(this.value);
    this.model = this.toDate();
    this.change({model: this.model, value: this.value});
    this.destroy();
  }
}

export {DatePicker};